import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@/constants';

/**
 * Fallback redirect for legacy /payment/checkout/confirmation URLs.
 * Preserves query params (?status=success, ?status=canceled).
 */
export default function PaymentCheckoutRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${ROUTES.CHECKOUT_CONFIRMATION}${search}`} replace />;
}
